import { render, staticRenderFns } from "./BasicAsyncSelect.vue?vue&type=template&id=3354669a&scoped=true&"
import script from "./BasicAsyncSelect.vue?vue&type=script&lang=js&"
export * from "./BasicAsyncSelect.vue?vue&type=script&lang=js&"
import style0 from "./BasicAsyncSelect.vue?vue&type=style&index=0&id=3354669a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3354669a",
  null
  
)

export default component.exports